<template>
  <div v-loading="!hasTableStructure" class="sheet-table">
    <base-table
      v-if="hasTableStructure"
      ref="baseTable"
      show-line-height-box
      lazy
      :stripe="theme === 'standard'"
      :data="tableData"
      :empty-text="hasTableData ? '暂 无 数 据' : '加 载 中 ...'"
      :show-pointer="showPointer"
      :page-info="pageInfo"
      row-id="id"
      :tree-config="treeConfig"
      :line-height-level="lineHeightLevel"
      :real-count="realCount"
      @update:lineHeightLevel="updateLineHeightLevel"
      @page-change="refreshData()"
      @size-change="sizeChange"
      @cell-click="rowClick"
      @get-real-total="getRealTotal"
      @selection-change="$emit('selection-change', $event)"
      @scroll="onTableScrollThrottle"
      @resizable-change="onColumnResize"
    >
      <vxe-column
        fixed="left"
        align="center"
        v-if="showSelection"
        :width="columnWidth['selection'] || 50"
        :min-width="50"
      >
        <template v-slot:header>
          <div class="selection-header">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <el-dropdown trigger="click" @command="handleCompanyChange" placement="bottom-start">
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="本页">选择本页数据</el-dropdown-item>
                <el-dropdown-item command="全部">选择全部数据</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <template #default="{row}">
          <div :class="{ 'selection-wrapper': true, checked: row.checked }" @click.stop>
            <el-checkbox v-model="row.checked" @change="handleCheckOneChange(row)"></el-checkbox>
            <span v-tip class="idx">{{ row.idx }}</span>
          </div>
        </template>
      </vxe-column>
      <vxe-column v-if="deleteVisible" fixed="left" align="center" width="60" :min-width="50">
        <template #default="{row}">
          <el-tooltip content="解除关联" placement="top">
            <el-button
              @click.stop="$emit('delete-click', row)"
              type="text"
              size="small"
              icon="el-icon-delete"
              style="padding: 0px 12px;"
            ></el-button>
          </el-tooltip>
        </template>
      </vxe-column>
      <vxe-column
        v-for="col in tableFields"
        :key="col.value"
        :title="col.value"
        :width="
          columnWidth[col.value]
            ? columnWidth[col.value]
            : tableFields.length > 7
            ? setColumnWidth(col.label)
            : ''
        "
        :min-width="70"
        align="left"
        :fixed="col.fixed"
        :tree-node="treeKey && col.main"
      >
        <template v-slot:header>
          <div class="column-header" @click="headerClick(col)">
            <span v-tip class="span-tip">
              {{ col.label }}
              <!-- 控件提示 -->
              <el-tooltip v-if="col.description" :content="col.description" placement="bottom">
                <span class="icon-tip pointer">
                  <i class="el-icon-info"></i>
                </span>
              </el-tooltip>
              <template v-if="sortItem.key == col.cid">
                <svg-icon
                  v-if="sortItem.direction === 'ASC'"
                  icon-class="svgo_sort-asc"
                  class="sort-icon"
                ></svg-icon>
                <svg-icon
                  v-else-if="sortItem.direction === 'DESC'"
                  icon-class="svgo_sort-desc"
                  class="sort-icon"
                ></svg-icon>
              </template>
            </span>
            <el-dropdown trigger="click" @command="btnClick($event, col)">
              <span class="el-dropdown-link" @click.stop>
                <svg-icon icon-class="svgo_arrow-down"></svg-icon>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="sortAsc">
                  <svg-icon icon-class="svgo_sort-asc"></svg-icon>
                  升序
                </el-dropdown-item>
                <el-dropdown-item command="sortDesc">
                  <svg-icon icon-class="svgo_sort-desc"></svg-icon>
                  倒序
                </el-dropdown-item>
                <el-dropdown-item v-show="!col.main && !col.fixed" command="lock">
                  <svg-icon icon-class="svgo_lock"></svg-icon>
                  冻结
                </el-dropdown-item>
                <el-dropdown-item v-show="!col.main && col.fixed" command="unlock">
                  <svg-icon icon-class="svgo_unlock"></svg-icon>
                  解冻
                </el-dropdown-item>
                <el-dropdown-item v-show="col.isRef != true" command="hide">
                  <svg-icon icon-class="svgo_tableHide"></svg-icon>
                  隐藏
                </el-dropdown-item>
                <el-dropdown-item v-show="colFilter" command="filter">
                  <svg-icon icon-class="filter" style="font-size: 16px"></svg-icon>
                  筛选
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <template #default="{row}">
          <div v-if="treeKey && col.main" class="tree-title-wrapper">
            <span v-tip>{{ _.get(row, col.value) }}</span>
            <base-dropdown
              ref="subDropdown"
              width="100"
              popover-class="tree-sub-dropdown"
              @hide="curFocusedSheetData = {}"
            >
              <template #reference>
                <el-tooltip content="新建" placement="top">
                  <svg-icon
                    :class="['add-btn', row.id === curFocusedSheetData.id ? 'focus' : '']"
                    icon-class="plus"
                    @click.native.stop="clickAddBtn(row)"
                  ></svg-icon>
                </el-tooltip>
              </template>
              <div class="tree-sub-item pointer" @click="createSubData(row)">新建子级</div>
              <div class="tree-sub-item pointer" @click="addFromRoot(row)">复制已有的</div>
            </base-dropdown>
          </div>
          <sheet-table-cell
            v-else
            :sheet-data="row"
            :control="col.rawControl || col"
            :file-map="fileMap"
            :watermark="userInfo"
            @open-detail-dialog="openDetailDialog"
            :from="from"
          ></sheet-table-cell>
        </template>
      </vxe-column>
      <!-- 防止列太短，所以使用此列占位 -->
      <vxe-column v-if="!isAutoWidth" :min-width="1" :resizable="false"></vxe-column>
      <vxe-column
        v-if="btnColumnVisible"
        fixed="right"
        title="操作"
        :resizable="false"
        width="134px"
      >
        <template #default="{row}">
          <div @click.stop="" style="display:flex">
            <el-button
              v-for="(btn, index) in row.btnMenuList.slice(0, 2)"
              :key="index"
              type="text"
              class="scope-btn"
              @click="clickBtn(btn.command, row)"
            >
              <el-tooltip
                :disabled="_.isEmpty(btn.desc)"
                effect="dark"
                :content="btn.desc"
                placement="top"
              >
                <span v-if="_.isEmpty(btn.desc)" v-tip>
                  {{ btn.title }}
                </span>
                <span v-else>
                  {{ btn.title.slice(0, 2) + (btn.title.length > 2 ? "..." : "") }}
                </span>
              </el-tooltip>
            </el-button>
            <dropdown-menu
              v-if="row.btnMenuList.length > 2"
              :menu-list="row.btnMenuList.slice(2)"
              placement="bottom-end"
              from="detailDialog"
              @click="clickBtn($event, row)"
            >
              <i class="el-icon-more" style="margin-left:10px;"></i>
            </dropdown-menu>
          </div>
        </template>
      </vxe-column>
      <template #footer>
        <summary-row
          v-if="showReport"
          :key="viewId"
          ref="summary"
          :fields="tableFields"
          :view-id="viewId"
          :report="report"
          :table-col-width="realColWidth"
          :conditions="conditions"
        ></summary-row>
      </template>
    </base-table>
    <detail-dialog
      ref="detailDialog"
      :visible.sync="detailDialogVisible"
      :data-id="visitDataId"
      :app-id="visitAppId"
      :table-data-ids="tableDataIds"
      @data-changed="refreshData"
      @trun-page="trunPage"
      :control="filedInfo"
    ></detail-dialog>
    <!--编辑数据-->
    <edit-dialog
      ref="editDialog"
      :from="editDialogType"
      :sheet-id="sheetData.sheetId"
      :data-id="dataId"
      :init-data="copyData"
      @after-submit="dataSubmitted"
    ></edit-dialog>
    <!--选择打印模板 -->
    <select-print-template ref="selectPrintTemplateDialog"></select-print-template>
    <!--选择同步信息 -->
    <sync-data-dialog
      ref="syncDataDialog"
      :sheet-id="sheetDef.sheetId"
      :selection="selection"
      :app-id="sheetDef.appId"
    ></sync-data-dialog>
    <!--设置关联项目-->
    <set-related-project-dialog
      ref="setRelatedProjectDialog"
      @change="relatedProjectChanged"
      :sheet-data-id="dataId"
      :sheet-id="sheetData.sheetId"
      :project-id="sheetData.projectId"
    ></set-related-project-dialog>
    <!--按钮关联新建-->
    <edit-dialog
      ref="btnEditDialog"
      from="reference"
      :sheet-id="btnSheetId"
      :data-id="btnDataId"
      :refDataInfo="{
        _ccid: btnCcid,
        data: btnSheetData
      }"
      @after-submit="dataSubmitted"
    ></edit-dialog>
    <!--按钮填写-->
    <fill-dialog
      ref="fillDialog"
      from="fillForm"
      :sheet-id="btnSheetId"
      :data-id="btnDataId"
      :btn-source-data-id="dataId"
      :btn-source-app-id="btnSheetDef.appId"
      :btn-info="activeCustomBtn"
      @after-submit="dataSubmitted"
    ></fill-dialog>
    <template v-if="treeKey">
      <!--新建子数据-->
      <edit-dialog
        ref="subEditDialog"
        from="reference"
        :sheet-id="sheetData.sheetId"
        :refDataInfo="{
          _ccid: _.get(fieldMap[treeKey], '_ccid'),
          data: sheetData
        }"
        @after-submit="subDataCreated"
      ></edit-dialog>
      <!--从已有根节点新增-->
      <ref-data-dialog
        hide-create
        first-level-only
        :control="refControlForAdd"
        :ref-sheet="sheetDef"
        :ref-condition="{}"
        :dialog-visible.sync="addRefDataDialogVisible"
        @select="refDataSelected"
      ></ref-data-dialog>
    </template>
  </div>
</template>

<script>
import { getSheetViewData } from "@/api/sheet/sheetView"
import SummaryRow from "./SummaryRow"
import { transFieldControl } from "@/utils/sheet"
import { gatherTypeMap, systemFields } from "./static"
import BaseTable from "@/components/UIComponents/NewTable.vue"
import { url_prefix } from "@/utils/uploadFile"
import { deepClone } from "@/utils/common"
import { getAttachmentListById } from "@/api/userCenter/file"
import { setFrontSetting, getFrontSetting } from "@/api/user"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import SelectPrintTemplate from "@/components/Sheet/DetailDialog/SelectPrintTemplate"
import SetRelatedProjectDialog from "@/components/Sheet/DetailDialog/SetRelatedProjectDialog"
import { addRelatedData, getSheet } from "@/api/sheet/sheet"
import BaseDropdown from "@/components/UIComponents/Dropdown"
import BtnMixin from "@/components/UIComponents/BtnMixin"
import SheetTableCell from "./SheetTableCell.vue"
import SyncDataDialog from "@/views/Front/Sheet/View/SyncDataDialog"
import { getCurUser } from "@/api/user"

export default {
  name: "SheetTable",
  components: {
    BaseDropdown,
    SummaryRow,
    BaseTable,
    DropdownMenu,
    SelectPrintTemplate,
    SetRelatedProjectDialog,
    SheetTableCell,
    SyncDataDialog
  },
  props: {
    view: Object,
    deleteVisible: Boolean,
    conditions: Array,
    refCond: {}, // 用户关联表筛选
    showReport: Boolean, // 是否显示汇总行
    showSelection: {
      // 是否显示最前面的 selection 列
      type: Boolean,
      default: true
    },
    showBtnColumn: {
      // 是否显示最后面的按钮列
      type: Boolean,
      default: true
    },
    showPointer: {
      // 移到表格的某一行上时，鼠标变成 pointer 的状态
      type: Boolean,
      default: true
    },
    showLineHeightBox: Boolean,
    openDetail: {
      type: Boolean,
      default: true
    },
    rowClickCbk: {
      // 需要自定义行点击事件时传入
      type: Function
    },
    initialLineHeightLevel: String,
    showProjectColumn: Boolean,
    firstLevelOnly: Boolean, // 当树形结构时,是否只展示第一级
    columnHide: { type: Object, default: () => ({}) },
    colFilter: Boolean,
    pageSize: Number
  },
  data() {
    return {
      url_prefix,
      systemFields,
      sheetDef: {},
      tableData: [],
      realColWidth: {},
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      getTableDataDebounced: this._.debounce(this.initTableData, 100), // 为了避免外部短时间内修改多次props,所以加了个提前防抖
      allFields: [],
      tableFields: [],
      treeKey: null, // 非空则以树状展示
      hasTableStructure: false, // 请求了表格结构
      hasTableData: false, // 请求了表格数据
      refCondSearch: {},
      report: { appId: "" }, // 列汇总
      gatherTypeMap,
      detailDialogVisible: false,
      visitDataId: "", // 打开 detail-dialog 的 dataId
      visitAppId: "", // 打开 detail-dialog 的 appId
      select: "本页",
      checkAll: false,
      isIndeterminate: false,
      sortItem: {
        key: "",
        direction: ""
      },
      editDialogType: "edit",
      copyData: null,
      dataId: "", // 当前操作的数据Id
      sheetData: {}, // 当前操作的数据
      // 按钮相关
      btnSheetDef: {},
      btnSheetId: "",
      btnDataId: "",
      btnCcid: "",
      btnSheetData: {},
      activeCustomBtn: {}, // 当前点击的自定义btn
      sorts: [],
      structInitPromise: null,
      addRefDataDialogVisible: false,
      parentMap: {},
      columnWidth: {},
      columnLock: [],
      front: {},
      curFocusedSheetData: {}, // 当前点击加号的数据
      files: [],
      onTableScrollThrottle: this._.throttle(this.onTableScroll, 20),
      from: "SheetTable",
      selection: {
        command: "本页",
        length: 1,
        tableData: []
      },
      realCount: false,
      userInfo:"",
      filedInfo:Object
    }
  },
  mounted() {
    getCurUser().then((res) => {
      this.userInfo=res.data.data.name;
    })
  },
  mixins: [BtnMixin],
  computed: {
    isAutoWidth() {
      return this._.isEmpty(this.columnWidth) && this.tableFields.length <= 7
    },
    theme() {
      return this.$store.getters.theme
    },
    tableDataIds() {
      if (!this.tableData?.length) return []
      return this.tableData.map(i => i.id)
    },
    fieldMap() {
      return this._.keyBy(this.allFields, "_cid")
    },
    refControlForAdd() {
      return {
        refSheetId: this.sheetDef.sheetId,
        fields: (this.sheetDef.controls || []).map(c => c._cid),
        treeKey: this.treeKey
      }
    },
    lineHeightLevel() {
      return this.front?.lineHeightLevel?.level || this.initialLineHeightLevel
    },
    viewId() {
      return this.view?.id
    },
    fileIds() {
      let fileIds = []
      let fileControlIdMap = {}
      this.tableFields?.forEach(field => {
        if (["sign", "file"].includes(field.type)) fileControlIdMap[field.cid] = field.type
      })
      this.tableData?.forEach(item => {
        let data = item.data
        let dataIds = this._.keys(data)
        for (let dataId of dataIds) {
          if (this._.keys(fileControlIdMap).includes(dataId)) {
            if (fileControlIdMap[dataId] === "sign") {
              fileIds.push(data[dataId + "_f"])
            }
            if (fileControlIdMap[dataId] === "file") {
              fileIds = fileIds.concat(data[dataId + "_f"])
            }
          }
        }
      })
      return fileIds
    },
    fileMap() {
      return this.files.reduce((acc, cur) => Object.assign(acc, { [cur.id]: cur }), {})
    },
    treeConfig() {
      if (!this.treeKey) return null
      return {
        rowField: "id",
        lazy: true,
        children: "children",
        hasChild: "hasChildren",
        loadMethod: this.loadTableData,
        indent: 10
      }
    },
    btnColumnVisible() {
      return this.view?.showButton && this.showBtnColumn
    }
  },
  watch: {
    view: {
      immediate: true,
      handler() {
        this.initAll()
      }
    },
    conditions: {
      handler(newVal, oldVal) {
        if (this._.isEqual(newVal, oldVal)) return
        this.pageInfo.currentPage = 1
        this.refreshData()
      }
    },
    refCond: {
      handler(newVal, oldVal) {
        this.refCondSearch = newVal
      },
      deep: true,
      immediate: true
    },
    fileIds: {
      handler(newVal, oldVal) {
        if (newVal.length) {
          this.getFilesMap()
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Sheet/DetailDialog").default
    this.$options.components.EditDialog = require("@/components/Sheet/EditDialog").default
    this.$options.components.FillDialog = require("@/components/Sheet/FillDialog").default
    this.$options.components.RefDataDialog = require("@/components/Sheet/RefDataDialog").default
  },
  methods: {
    async sizeChange(size) {
      this.$emit("size-change", size)
      await setFrontSetting(size, this.sheetDef.sheetId, "pageSize")
      // 清除工作表个人设置缓存
      await getFrontSetting(this.sheetDef.sheetId, false)
      this.reSearch()
    },
    reSearch() {
      this.pageInfo.currentPage = 1
      this.refreshData()
    },
    refreshData(sheetData) {
      if (this.treeKey && sheetData) {
        this.$refs.baseTable.reloadTreeExpand(sheetData)
      } else {
        this.hasTableData = false
        this.getTableDataDebounced()
      }
    },
    resetTableDataStatus() {
      this.hasTableData = false
      this.tableData = []
    },
    getRealTotal() {
      this.realCount = true
      this.initTableData()
    },
    initTableData() {
      if (!this.viewId) return
      this.resetTableDataStatus()
      this.select = "本页"
      this.checkAll = false
      this.isIndeterminate = false
      this.$emit("selection-change", {
        tableData: [],
        length: 0,
        command: "本页"
      })
      return getSheetViewData({
        viewId: this.viewId,
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize,
        conditions: this.conditions,
        sorts: this.sorts,
        ...this.refCondSearch,
        realCount: this.realCount
      })
        .then(async res => {
          await this.structInitPromise // 等待treeKey请求完成
          let tableData = this.dealTableData(res.content)
          tableData.forEach(row => (row.deep = 0))
          this.tableData = tableData
          this.pageInfo.total = res.totalElements
          this.$refs.summary?.refreshReports()
        })
        .finally(() => (this.hasTableData = true))
    },
    getFilesMap() {
      getAttachmentListById(this.fileIds).then(files => {
        this.files = files
      })
    },
    rowClick({ row, column, triggerTreeNode }) {
      if (triggerTreeNode || column.type === "selection") return
      if (this.rowClickCbk) {
        this.rowClickCbk(row)
      }
      if (this.openDetail) {
        this.visitAppId = this.sheetDef.appId
        this.visitDataId = row.id
        this.detailDialogVisible = true
        this.filedInfo=this.sheetDef
        console.log("rowClick" ,this.sheetDef)
      }
    },
    async initSheetStruct() {
      if (!this.viewId) return
      this.pageInfo = { total: 0, currentPage: 1, pageSize: this.pageSize || 20 }
      this.resetTableDataStatus()
      this.hasTableStructure = false
      let [front] = await Promise.all([getFrontSetting(this.viewId), this.$nextTick()])
      this.front = front || {}
      this.columnWidth = this.front.columnWidth || {}
      this.columnLock = this.front.columnLock || []
      this.allFields = this.view.fields
      if (this.view.type === "TREE") {
        this.treeKey = this.view.treeKey
      }
      return Promise.all([
        new Promise(resolve =>
          setTimeout(() => {
            this.updateColWidth()
            resolve()
          })
        ),
        getSheet(this.view.sheetId).then(sheet => {
          this.sheetDef = sheet
          this.tableFields = this.transFields(this.view.fields)
          this.hasTableStructure = true
        })
      ])
    },
    async initAll() {
      this.structInitPromise = await this.initSheetStruct()
      this.initTableData()
    },
    onTableScroll({ isX, scrollLeft }) {
      if (!isX || !this.$refs.summary) return
      this.$refs.summary.$refs.summaryWrapper.scrollLeft = scrollLeft
    },
    openDetailDialog(row, v) {
      this.visitDataId = this._.get(row.data, v + "_id")
      this.visitAppId = this._.get(row.data, v + "_appId")
      this.detailDialogVisible = true
    },
    updateColWidth() {
      let columns = this.$refs.baseTable?.$refs.table?.tableFullColumn
      if (!columns) return
      this.realColWidth = columns.reduce(
        (acc, col) => Object.assign(acc, { [col.title]: col.renderWidth }),
        {}
      )
    },
    onColumnResize() {
      this.updateColWidth()
      setFrontSetting(this.realColWidth, this.viewId, "columnWidth").then(() => {
        this.columnWidth = this._.cloneDeep(this.realColWidth)
      })
    },
    trunPage(dataId) {
      this.visitDataId = dataId
      this.$nextTick(() => this.$refs.detailDialog.init())
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      this.tableData.forEach(item => {
        item.checked = val
      })
      let select = {}
      if (val) {
        if (this.select == "本页") {
          select = {
            tableData: this.tableData,
            length: this.tableData.length,
            command: this.select,
            firstDataId: this.tableData[0]?.id
          }
        } else {
          select = {
            tableData: [],
            length: this.pageInfo.total,
            command: this.select,
            firstDataId: this.tableData[0]?.id
          }
        }
        this.$emit("selection-change", select)
      } else {
        this.select = "本页"
        select = {
          tableData: [],
          length: 0,
          command: "本页"
        }
        this.$emit("selection-change", select)
      }
    },
    handleCheckOneChange(val) {
      let selectedData = []
      let totalCount = this.tableData.length
      let someStatusCount = 0
      this.tableData.forEach(item => {
        if (item.checked === true) {
          someStatusCount++
          selectedData.push(item)
        }
      })
      if (this.checkAll && this.select == "全部") {
        this.tableData.forEach(item => {
          item.checked = false
        })
        someStatusCount = 0
        this.checkAll = false
        selectedData = []
      } else {
        this.checkAll = totalCount === someStatusCount
      }
      this.isIndeterminate = someStatusCount > 0 && someStatusCount < totalCount
      let select = {
        tableData: selectedData,
        length: selectedData.length,
        command: "本页",
        firstDataId: selectedData[0]?.id
      }
      this.$emit("selection-change", select)
    },
    handleCompanyChange(command) {
      this.select = command
      this.checkAll = true
      this.handleCheckAllChange(true)
    },
    transFields(controls) {
      if (this._.isEmpty(controls)) return []
      // 计算普通字段
      let fields = controls
        .filter(field => !["remark", "code", "chart"].includes(field._type) && field.display)
        .map(field => transFieldControl(field))
        .map(field => {
          return {
            rawControl: field,
            cid: field._cid,
            label: field.name,
            value: `data.${field._cid}`,
            type: field._type,
            oneFlag: field.oneFlag,
            dataType: field._dataType,
            main: field.main && !this.showProjectColumn,
            description: field.description,
            fixed:
              (field.main && !this.showProjectColumn) || this.columnLock.includes(field._cid)
                ? "left"
                : null
          }
        })
      let main = fields.find(field => field.main == true)
      if (main) {
        fields.splice(fields.indexOf(main), 1)
        fields.unshift(main)
      }
      // 处理特殊字段
      if (this.showProjectColumn) {
        fields = [{ value: "projectName", label: "项目", fixed: "left" }].concat(fields)
      }
      let showSystemFields = this.systemFields.filter(
        systemField => !this.sheetDef.layout.hiddenCids.includes(systemField.cid)
      )
      fields = fields.concat(showSystemFields)
      return fields.filter(
        field =>
          !(this.columnHide[this.viewId] || []).includes(field.cid) &&
          !this.view.hides.includes(field.cid)
      )
    },
    headerClick(col) {
      if (this.sortItem.key == col.cid) {
        if (this.sortItem.direction == "ASC") this.sortItem.direction = "DESC"
        else {
          this.sortItem = {
            key: "",
            direction: ""
          }
          this.sorts = []
          return this.refreshData()
        }
      } else
        this.sortItem = {
          key: col.cid,
          direction: "ASC"
        }
      this.sorts = [this.sortItem]
      this.refreshData()
    },
    btnClick(command, col) {
      switch (command) {
        case "sortAsc":
          this.sortItem = {
            direction: "ASC",
            key: col.cid
          }
          this.sorts = [this.sortItem]
          this.refreshData()
          break
        case "sortDesc":
          this.sortItem = {
            direction: "DESC",
            key: col.cid
          }
          this.sorts = [this.sortItem]
          this.refreshData()
          break
        case "lock":
          col.fixed = "left"
          this.$refs.baseTable.refreshColumn()
          this.columnLock.push(col.cid)
          setFrontSetting(this.columnLock, this.viewId, "columnLock")
          break
        case "unlock":
          col.fixed = null
          this.$refs.baseTable.refreshColumn()
          this.columnLock.splice(this.columnLock.indexOf(col.cid), 1)
          setFrontSetting(this.columnLock, this.viewId, "columnLock")
          break
        case "hide":
          if (this.columnHide[this.viewId]) this.columnHide[this.viewId].push(col.cid)
          else this.$set(this.columnHide, this.viewId, [col.cid])
          setFrontSetting(this.columnHide, this.view.sheetId, "columnHide")
          this.tableFields.splice(this.tableFields.indexOf(col), 1)
          break
        case "filter":
          this.$emit("openFilter", col)
          break
      }
    },
    async clickBtn(command, row) {
      this.dataId = row.id
      this.sheetData = row
      switch (command) {
        case "edit":
          this.editDialogType = "edit"
          this.$refs.editDialog.open()
          break
        case "delete":
          await this.deleteSheetData(this.dataId, this.sheetDef.appId)
          this.refreshData(
            Object.assign(this.parentMap[this.sheetData.id] || {}, { hasChildren: true })
          )
          this.emitCountChange()
          break
        case "lock":
        case "unlock":
          await this.lockOrUnlockData(this.sheetData)
          this.refreshData()
          break
        case "print":
          this.$refs.selectPrintTemplateDialog.open({
            dataId: this.dataId,
            sheetId: this.sheetData.sheetId,
            appId: this.sheetDef.appId
          })
          break
        case "copy":
          this.editDialogType = "copy"
          this.handleCopyData(this.dataId, this.sheetDef.appId, this.sheetDef)
          break
        case "sync":
          this.selection.tableData = [row]
          this.$refs.syncDataDialog.open()
          break
        case "project":
          this.$refs.setRelatedProjectDialog.open()
          break
      }
      let btn = row.sheetBtnList.find(x => x.id == command)
      this.activeCustomBtn = btn
      switch (btn.actionType) {
        case "DIRECT": {
          await this.customBtnRequest(
            this.sheetDef.appId,
            this.dataId,
            btn.id,
            this.sheetDef.sheetId
          )
          this.refreshData()
          break
        }
        case "CONFIRM": {
          await this.$confirm(btn.confirmMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          await this.customBtnRequest(
            this.sheetDef.appId,
            this.dataId,
            btn.id,
            this.sheetDef.sheetId
          )
          this.refreshData()
          break
        }
        case "FILL": {
          await this.fill(btn, row.id, this.sheetDef.appId)
          break
        }
      }
    },
    async dataSubmitted(data, from) {
      if (from !== "reference") {
        this.refreshData()
        this.$emit("refreshNav")
      } else {
        let sheetData = this.btnSheetData
        let sheetDef = deepClone(this.btnSheetDef)
        await this.editReference(data, sheetData, sheetDef)
        this.refreshData()
        this.$emit("refreshNav")
      }
    },
    relatedProjectChanged() {
      this.refreshData()
    },
    loadTableData({ row }) {
      if (!this.treeKey) return Promise.resolve([])
      return getSheetViewData({
        viewId: this.viewId,
        page: 1,
        size: 0x7fffffff,
        conditions: this.conditions,
        sorts: this.sorts,
        ...this.refCondSearch,
        rootId: row.id,
        realCount: this.realCount
      }).then(res => this.dealTableData(res.content, row))
    },
    dealTableData(tableData, parentData) {
      if (this._.isEmpty(tableData)) {
        parentData && (parentData.hasChildren = false)
      } else {
        tableData.forEach((row, idx) => {
          if (parentData) {
            row.idx = parentData.idx + "." + (idx + 1)
          } else {
            row.idx = (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + (idx + 1) + ""
          }
          row.btnMenuList = this.btnMenuList(row.sheetBtnList)
          row.checked = false
          row.hasChildren =
            this.treeKey && !this.firstLevelOnly && !this._.isEmpty(row.data[this.treeKey + "_o"])
          row.parentId = parentData?.id
          row.deep = (parentData?.deep || 0) + 1
          this.parentMap[row.id] = parentData
        })
      }
      return tableData
    },
    createSubData(sheetData) {
      this.sheetData = sheetData
      this.$refs.subEditDialog.open()
    },
    addFromRoot(sheetData) {
      this.sheetData = sheetData
      this.addRefDataDialogVisible = true
    },
    refDataSelected(sheetData) {
      addRelatedData(this.sheetData.sheetId, this.sheetData.id, sheetData.id, this.treeKey).then(
        () => {
          this.$message.success("操作成功")
          this.refreshData(Object.assign(this.sheetData, { hasChildren: true }))
        }
      )
    },
    clickAddBtn(sheetData = {}) {
      // 关闭其他已经打开的下拉菜单
      this.$refs.subDropdown?.forEach(el => el.close())
      // 使当前点击的这行数据的加号一直显示($nextTick是为了防止上面close事件清空curFocusedSheetData)
      this.$nextTick(() => (this.curFocusedSheetData = sheetData))
    },
    subDataCreated() {
      this.refreshData(Object.assign(this.sheetData, { hasChildren: true }))
      this.emitCountChange()
    },
    emitCountChange() {
      this.$emit("count-change")
    },
    btnMenuList(btnList) {
      return btnList.map(btn => {
        if (btn.id.length === 24) {
          return {
            title: btn.name,
            command: btn.id,
            desc: btn.desc,
            icon: btn.icon ? "button_" + btn.icon : "button_icon-01",
            bgColor: btn.color && btn.color === "#1989fa" ? btn.color : "#fff",
            textColor: btn.color && btn.color === "#1989fa" ? "#fff" : "#1989fa"
          }
        } else {
          return {
            title: btn.name,
            command: btn.id,
            icon: "basic-button_" + btn.id
          }
        }
      })
    },
    updateLineHeightLevel(level) {
      this.$set(this.front, "lineHeightLevel", { level: level + "" })
      setFrontSetting({ level: level + "" }, this.viewId, "lineHeightLevel")
    },
    setColumnWidth(columnLabel) {
      // 左padding:10，右padding:10，设置(升序等):24
      let width = 44
      let str = columnLabel.trim().replace(new RegExp("\\s+"), " ")
      for (let char of str) {
        if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
          width += 10
        } else if (char >= "\u4e00" && char <= "\u9fa5") {
          width += 14
        } else if (char >= "0" && char <= "9") {
          width += 8
        } else {
          width += 10
        }
      }
      return width
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-table {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  .base-table {
    flex: 1;
    overflow: hidden;
    .tree-title-wrapper {
      display: flex;
    }
    .selection-header {
      // position: relative;
      height: 23px;
      width: 33px;
      // left: -10px;
      margin: auto;
    }
    .selection-wrapper {
      flex: 1;
      overflow: hidden;
      .el-checkbox {
        display: none;
      }
      &.checked,
      &:hover {
        .el-checkbox {
          display: inline;
        }
        .idx {
          display: none;
        }
      }
    }
    ::v-deep {
      .vxe-header--column.col--ellipsis > .vxe-cell {
        // 临时解决列过多时,vxe-table自动给列加上col--ellipsis导致的布局异常问题(未解决卡顿问题)
        display: block !important;
      }
      .vxe-table--body-wrapper tr.row--hover > td .add-btn,
      .add-btn.focus {
        display: inline !important;
      }
      .vxe-body--row {
        .add-btn {
          display: none;
          font-size: 14px;
          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
  .column-header {
    display: flex;
    align-items: center;
    .sort-icon {
      margin-left: 5px;
    }
  }
  .span-tip {
    max-width: calc(100% - 24px);
  }
  .el-dropdown {
    margin-left: auto;
  }
  .scope-btn {
    font-size: 13px;
    font-weight: 400;
    color: #1989fa;
    padding: unset;
    width: 41.84px;
  }
  ::v-deep {
    .el-table {
      .el-table__expand-icon {
        margin-right: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.tree-sub-dropdown {
  min-width: 50px !important;
  .tree-sub-item {
    text-align: center;
    padding: 5px;
    &:hover {
      background: #eee;
    }
  }
}
</style>
